import store from '../store/Store';
import { LivePersonaCardInitializationState } from '../store/schema/PersonaControlStore';

export function setLivePersonaCardInitializationStatus(
    newState: LivePersonaCardInitializationState
): void {
    store.livePersonaCardInitializationStatus = {
        state: newState,
        timestamp: Date.now(),
    };

    store.isLivePersonaCardInitialized =
        newState === LivePersonaCardInitializationState.Initialized;
}
